import Cookies from "js-cookie";
import axios from "axios";
import { AppConstants } from "./constants";
import { toast } from "react-toastify";
const cookieOptions = () => AppConstants.getCookieOptions();

export function logout() {
  localStorage.clear();
  Cookies.remove('acto', cookieOptions())
  Cookies.remove('reto', cookieOptions())
  Cookies.remove('domain', cookieOptions())


  window.open('/', '_self')
}

// --- Token refresh queue: prevents race conditions from parallel 401s ---
let isRefreshing = false;
let failedQueue: Array<{
  resolve: (token: string) => void;
  reject: (error: any) => void;
}> = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token!);
    }
  });
  failedQueue = [];
};

const fetchRefresh = async (): Promise<string> => {
  try {
    const response = await General.refresh();
    if (response && response.status === 200) {
      const newActo = response.data?.access_token;
      const newReto = response.data?.refresh_token;
      if (!newActo || !newReto) {
        AppConstants.redirectToSso();
        throw new Error("Invalid refresh response");
      }
      Cookies.set('acto', newActo, cookieOptions())
      Cookies.set('reto', newReto, cookieOptions())
      return newActo;
    }
    // Refresh returned non-200 — tokens are invalid
    AppConstants.redirectToSso();
    throw new Error("Refresh failed");
  } catch (error) {
    AppConstants.redirectToSso();
    throw error;
  }
};
// axios.defaults.baseURL = `${AppConstants.base_url_api}`;
axios.interceptors.request.use(
  (config) => {
    const token = Cookies.get('acto');
    if (token) config.headers.Authorization = token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(undefined, async (error) => {
  if (error.message === "Network Error" && !error?.response) {

  }
  if (error.response) {
    const { status, config } = error?.response;
    if (status) {
      if (status === 401 ) {
        if (!AppConstants.shouldRedirectToSso()) {
          throw error.response;
        }

        const reto = Cookies.get('reto');
        if (!reto) {
          AppConstants.redirectToSso();
          throw error.response;
        }

        // Another request is already refreshing — queue this one
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({
              resolve: (token: string) => {
                config.headers.Authorization = token;
                resolve(axios(config));
              },
              reject,
            });
          });
        }

        // Start token refresh
        isRefreshing = true;
        try {
          const newToken = await fetchRefresh();
          processQueue(null, newToken);

          // Retry the original failed request with the new token
          config.headers.Authorization = newToken;
          return axios(config);
        } catch (refreshError) {
          processQueue(refreshError, null);
          throw error.response;
        } finally {
          isRefreshing = false;
        }
      }
      if (status === 200) {
        // return error;
      }
      if (status === 403) {
        if (Cookies.get('reto') && AppConstants.shouldRedirectToSso()) {
          toast.info("شما اجازه دسترسی به این بخش را ندارید")
          AppConstants.redirectToSso();
        } 
      }
      if (status === 404) {
        // fetchRefresh()
        // return error;
      }
      if (status === 400) {

      }
      if (status === 500) {
        // window.location.href = '/server-error'
      }
    }
  }

  throw error.response;
});

const responseBody = (response: any) => {
  return response;
};
const errorBody = (error: any) => {
  return error;
};

const requests = {
  get: (url: string) => axios.get(url).then(responseBody).catch(errorBody),
  post: (url: string, body: any) =>
    axios.post(url, body).then(responseBody).catch(errorBody),
  put: (url: string, body: any) => axios.put(url, body).then(responseBody).catch(errorBody),
  del: (url: string) => axios.delete(url).then(responseBody).catch(errorBody),
  postForm: (url: string, files: any,text:string ) => {
    let formData = new FormData();
    if(files){
      if (Array.isArray(files)) {
        files.forEach((file: any) => {
          formData.append("files", file);
        });
      } else {
        formData.append("files", files);
      }
    }

    formData.append("text", text);

    return axios
      .post(url, formData, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody).catch(errorBody)
  },
  postFormVideo: (url: string, Video: string | Blob) => {
    let formData = new FormData();
    formData.append('Video', Video);
    return axios
      .post(url, formData, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody).catch(errorBody);
  },
};
//
const General = {
  refresh: () => requests.post(`${AppConstants.sso_api_url}refresh/`, { refresh: `${Cookies.get('reto')}` }),
}
const User = {
  profile: () => requests.get(`${AppConstants.base_url_api}profile/`),
}
const Doc = {
  doc: () => requests.get(`${AppConstants.base_url_api}doc/categories/`),
  create: (data:any) => requests.post(`${AppConstants.base_url_api}doc/plan-present/`,data),
}
const Ticket = {
  list: (search:any) => 
   requests.get(`${AppConstants.base_url_api}tickets/${search}`),
  create: (subject: string,description:string,assgin_to_id:string) => requests.post(`${AppConstants.base_url_api}ticket/`, { subject,description,assgin_to_id}),
  details: (id:string) => requests.get(`${AppConstants.base_url_api}ticket/${id}/detail/`),
  assignPersonsList: () => requests.get(`${AppConstants.base_url_api}ticket/assign-persons/`),
  answer: (text : string,id :string,files:any) => requests.postForm(`${AppConstants.base_url_api}ticket/${id}/detail/`, files,text),
  assignTo: (ticket_id : string,assgin_to_id :string) => requests.post(`${AppConstants.base_url_api}ticket/assign-to/`, {ticket_id,assgin_to_id}),
  states: () => requests.get(`${AppConstants.base_url_api}ticket/states/`),
  assignToDealModel: (member_id : number,lead_id :number, ticket_id:string, estimate_premium:string, 
    description:string, stage_id:number) => 
  requests.post(`${AppConstants.base_url_api}lead/deal/${lead_id}/append/`,
   {member_id, ticket_id, estimate_premium, description, stage_id	}),
  getCompletion : (ticket_id:string) => requests.get(`${AppConstants.base_url_api}lead/ticket/${ticket_id}/info/`),
  editCompletion:  (ticket_id:string, data:any) => requests.put(`${AppConstants.base_url_api}lead/ticket/${ticket_id}/info/`, data),
  getInsuranceEndTime : (ticket_id:string) => requests.get(`${AppConstants.base_url_api}lead/ticket/${ticket_id}/end-date/`),
  addInsuranceEndTime:(end_date : string,insurance_title :string, product_title:string, ticket_id:string) => 
  requests.post(`${AppConstants.base_url_api}lead/ticket/${ticket_id}/end-date/`,
   {end_date, insurance_title, product_title})

}


const Calender = {
  list: (start_date:string,end_date:string) => 
    requests.get(`${AppConstants.base_url_api}calender/?start_date=${start_date}&end_date=${end_date}`),
  create: (to_date: string,subject:string,descriptions:string,ticket:string) => requests.post(`${AppConstants.base_url_api}calender/`, { to_date,subject,descriptions,ticket}),

  holiday: (start_date:string,end_date:string) => 
    requests.get(`${AppConstants.base_url_api}calender/holiday/?start_date=${start_date}&end_date=${end_date}`),

}
const Leads = {
  list: (search:any) => 
   requests.get(`${AppConstants.base_url_api}leads/${search}`),
  leadDataList: (search:any) => 
  requests.get(`${AppConstants.base_url_api}lead/${window.location.pathname.split("/")[2]}/data/${search}`),
  ticket: (lead_id : number, count:number, user_id :number) => requests.post(`${AppConstants.base_url_api}lead/send-ticket/`, {lead_id, count, user_id}),
  states: () => requests.get(`${AppConstants.base_url_api}lead/state/`),
  updateState: (id:number, state_id:number) => requests.put(`${AppConstants.base_url_api}lead/${id}/change-state/`, {state_id,}),
  getDetails: (id:number) => requests.get(`${AppConstants.base_url_api}lead/${id}/info/`),
  LeadList: ()=>requests.get(`${AppConstants.base_url_api}lead/${window.location.pathname.split("/")[2]}/`),
  Add : (data: any)=> requests.post(`${AppConstants.base_url_api}lead/${window.location.pathname.split("/")[2]}/`, data),

}
const LeadsMember = {
  list: () => 
  requests.get(`${AppConstants.base_url_api}members/`),
}
const Deals = {
  modelList: (search?:any) => {
    if(search){
     return requests.get(`${AppConstants.base_url_api}lead/deals/${search}`)
    }
    else{
     return requests.get(`${AppConstants.base_url_api}lead/deals/`)
    }
  },
  list:(search:string)=> requests.get(`${AppConstants.base_url_api}lead/deal/${window.location.pathname.split("/")[2]}/data/${search}`),
   create: (title:string) =>
    requests.post(`${AppConstants.base_url_api}lead/deal/`, { title }),
  update: (title:string, id:string) =>
    requests.put(`${AppConstants.base_url_api}lead/deal/${id}/`, { title }),
    delete: (id:number)=>
    requests.del(`${AppConstants.base_url_api}lead/deal/${id}/`),
  statesList:()=>requests.get(`${AppConstants.base_url_api}lead/deal/state/`),
  changeStage:( stage_id:number, id:number | string, deal_data_id:number)=> requests.put(`${AppConstants.base_url_api}lead/deal/${id}/change-stage/`, {deal_data_id, stage_id}),
  changeState:( state_name:string, id:number, deal_data_id:number)=> requests.put(`${AppConstants.base_url_api}lead/deal/${id}/change-state/`, {deal_data_id, state_name}),
}
const Stage = {
  list: (search?:any) => 
   requests.get(`${AppConstants.base_url_api}lead/stages/${window.location.pathname.split("/")[2]}/${search ? search : ""}`),
  listWithDealId:(deal_id:number)=> requests.get(`${AppConstants.base_url_api}lead/stages/${deal_id}/?count=20`),
   create: (name:string,title:string, priority:number, estimate_percent:number) =>
    requests.post(`${AppConstants.base_url_api}lead/stage/${window.location.pathname.split("/")[2]}/`, {name,title, priority, estimate_percent})
   ,
  update: (name:string,title:string, priority:number, estimate_percent:number, id:number) =>
    requests.put(`${AppConstants.base_url_api}lead/stage/${window.location.pathname.split("/")[2]}/${id}/`, { name, title, priority, estimate_percent }),
    delete: (id:number)=>
    requests.del(`${AppConstants.base_url_api}lead/stage/${window.location.pathname.split("/")[2]}/${id}/`),
}
const Insurance ={
  list: () => 
  requests.get(`${AppConstants.base_url_api}insurance/`),
}
const Products = {
  list: () => 
  requests.get(`${AppConstants.base_url_api}product/`),
}
const Dashboard  = {
  list: () => 
  requests.get(`${AppConstants.base_url_api}dashboard/`),
}
const Notification = {
  list: () => 
  requests.get(`${AppConstants.base_url_api}notification/`),
}
export default {
  Dashboard,
  Ticket,
  Leads,
  User,
  Stage,
  Calender,
  LeadsMember,
  Insurance,
  Products,
  Deals,
  Notification,
  Doc
};

